import React from 'react';

import { graphql } from 'gatsby';

import GridSection from 'design-system/src/components/organisms/GridSection';

export default function GridPricingSection({
    items,
    variantLarge,
    ...props
}: any) {
    return (
        <GridSection
            {...props}
            variant="grid-pricing-1"
            items={items?.map((i: any) => ({
                ...i,
                variant: variantLarge ? 'large' : 'small',
            }))}
        />
    );
}

export const query = graphql`
    fragment DatoCmsGridPricingSection on DatoCmsGridPricingSection {
        title
        titleTag
        cta {
            ...Button
        }
        items: plans {
            title
            description
            features
            value: pricing
            theme: color
            cta {
                ...Button
            }
        }
        variantLarge
    }
`;
